module.exports = __webpack_public_path__ + "static/media/10.6a72c40b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/10.jpg
// module id = 469
// module chunks = 0